/**
 * Data visualization: Ochre colors
 */
export var ochre10 = '#fbc9b0';
export var ochre20 = '#f3a67f';
export var ochre20opacity20solidDark = '#4e4442';
export var ochre30 = '#e88b5d';
export var ochre40 = '#d67544';
export var ochre40opacity20solid = '#f7e3da';
export var ochre40opacity20solidDark = '#483b36';
export var ochre50 = '#b85d32';
export var ochre60 = '#a65127';
export var ochre60opacity20solid = '#eddcd4';
export var ochre70 = '#843f1c';
export var ochre80 = '#612d14';
